import { render, staticRenderFns } from "./EmptySidebar.vue?vue&type=template&id=7145ca98&scoped=true"
import script from "./EmptySidebar.vue?vue&type=script&lang=js"
export * from "./EmptySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145ca98",
  null
  
)

export default component.exports